import { Address } from '../../../lib/models/api/address.model';

import { Deserializable } from '../../../lib/models/deserializable';
import { ExistingPropertyParticipant } from './existing-property-participant.model';

export class ExistingProperty implements Deserializable {
  public ExistingPropertyID: number;
  public PropertyTypeCode: string;
  public PropertyCategoryCode: string;
  public SalePrice?: number;
  public AcquiredYear?: number;
  public OriginalPurchasePrice?: number;
  public MortgageInstitutionCode: string;
  public PropertyAddressID?: number;
  public CreatedDate?: Date;
  public HowManyPeopleInterestedInProperty?: number;
  public EstimatedMonthlyRentalIncome?: number;
  public CurrentInterestRate: string;
  public OutstandingMortgageBalance?: number;
  public AccountNumber: string;
  public MortgageOnThisPropertyCode: string;
  public DrawdownDate?: Date;
  public Address: Address;
  public ExistingPropertyParticipants: Array<ExistingPropertyParticipant>;
  public IsDeleted: boolean;

  deserialize(input: any): this {
    Object.assign(this, input);
    this.Address = new Address().deserialize(input.Address);
    if (input.ExistingPropertyParticipants) {
      this.ExistingPropertyParticipants = input.ExistingPropertyParticipants.map((existingPropertyParticipant) =>
        new ExistingPropertyParticipant().deserialize(existingPropertyParticipant)
      );
    }

    return this;
  }
}
